import { createContext, useContext } from 'react';
import { type LanguageOption } from '@/src/utils';

interface PageContextType {
    subheaderType: 'default' | 'hero';
    setSubheaderType: (type: 'default' | 'hero') => void;
    pageGrade: string;
    setPageGrade: (pageGrade: string) => void;
    subheaderTitle: string;
    setSubheaderTitle: (title: string) => void;
    validateGrade: (grade: string) => boolean;
    pageUnit: number;
    setPageUnit: (unit: number) => void;
    pageLanguage: LanguageOption;
    setPageLanguage: (language: LanguageOption) => void;
    pageLesson: number;
    setPageLesson: (lesson: number) => void;
    globalLoading: boolean;
    setGlobalLoading: (loading: boolean) => void;
}

export const PageContext = createContext<PageContextType | undefined>(undefined);

export const usePage = () => {
    const context = useContext(PageContext);
    if (context === undefined) {
        throw new Error('usePage must be used within a PageProvider');
    }
    return context;
};
